<template>
  <component
    :is="resolvedComponent"
    v-bind="phosphorProps"
    :size="size"
    :color="color"
    :weight="weight"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
// Import only icons we use explicitly to keep bundle lean.
// Extend this map as you migrate more icons.
// New official package replacing legacy phosphor-vue
import * as PhIcons from '@phosphor-icons/vue';

export interface IconProps {
  /** canonical phosphor kebab-case name (e.g. gear-six, pencil-simple) */
  name: string;
  size?: number;
  color?: string;
  weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
}

const props = withDefaults(defineProps<IconProps>(), {
  size: 16,
  weight: 'regular',
});

function kebabToPascal(kebab: string): string {
  return kebab.split('-').map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('');
}

const resolvedComponent = computed(() => {
  const key = 'Ph' + kebabToPascal(props.name);
  return (PhIcons as any)[key] || (PhIcons as any)['PhGearSix'];
});

const phosphorProps = computed(() => ({
  color: props.color,
}));

const size = computed(() => props.size);
const color = computed(() => props.color);
const weight = computed(() => props.weight);
</script>

<style scoped>
/* Phosphor icons already size via passed props; ensure alignment */
:deep(svg) { display: inline-block; vertical-align: middle; line-height: 1; }
</style>
